<template>
	<collapsible :is-collapsed="false" id="preview" class="custom-scrollbar">
		<settings-panel-area-header
				:open="!collapsible.collapsed"
				:plusMinus="true"
				header="PREVIEW"
				slot="toggle"
				slot-scope="collapsible"
		></settings-panel-area-header>
		<div class="preview" slot="content">
				<div >
					<div class="text" v-html="previewText">
					<!-- <div class="text"> -->
						<!-- {{previewText}} -->
					</div>
				</div>
			</div>

	</collapsible>
</template>

<script> 
	import Collapsible from '@/components/Collapsible'
	import SettingsPanelAreaHeader from '@/components/SettingsPanelAreaHeader'
	import SentencePreview from '@/assets/js/sentencePreview.js'

	export default {
		props: {
			preview: {
				type: Array
			}
		},
		computed: {
			previewText() {
				if (!this.preview) return ''
				return this.preview.map(s => (new SentencePreview(s)).getAsString()).join('')
			}
		},
		components: {
			Collapsible,
			SettingsPanelAreaHeader
		}
	}
</script>

<style lang="less">
	#preview {
		.preview {
			padding: 15px 0 15px 45px;
			// height: 500px;
			overflow: hidden;

			.text {
				padding-right: 45px;
				padding-bottom: 15px;
				
				a{pointer-events: none;}
			}
		}

		&.custom-scrollbar{
			&::-webkit-scrollbar-track {
				background: #333A3E;
			}
			&::-webkit-scrollbar-thumb {
				border: 2px solid #333A3E;
			}
			
		}
	}
	

	.content-header {
		margin-bottom: 20px;
	}

	.content-icon {
		margin-right: 10px;
		top: -2px;
		position: relative;
		width: 14px;
	}

	.content-text {
		color: #fff;
	}
</style>

